import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const InstrumentsRoutes: RouteBundle = {
  domain: 'instruments',
  routes: [
    {
      urlPattern: 'connection-schemas',
      handler: EditorRoutes.connectionSchemas.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: 'connection-schemas/create',
      handler: EditorRoutes.connectionSchemasCreate.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: 'connection-schemas/:schemaId',
      handler: EditorRoutes.connectionSchema.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: 'instrument-gateways',
      handler: EditorRoutes.instrumentGateways.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: 'connections/listing',
      handler: EditorRoutes.connectionListing.bind(EditorRoutes),
    },
    {
      urlPattern: 'connections/:connectionId',
      handler: EditorRoutes.connectionEditor.bind(EditorRoutes),
      legacy: true,
    },
  ],
};
